export const WINDOW_BREAKPOINTS = {
    MOBILE: 425,
    TABLET: 768, // md
    LAPTOP: 1024, // lg
    DESKTOP: 1440, // xl
}

